module.exports = __webpack_public_path__ + "img/3.5852cab6.png";